import controller from '../../Controller.js';
// import './Styles.css'; // imported from main bundle

function Toggle(toggle) {

    var trigger;
    function init() {
        trigger = toggle.querySelector('.toggle__control');
        var area = toggle.querySelector('.toggle__area');
        var id = '_' + Math.random().toString(36).substr(2, 9);

        var isExpanded = toggle.getAttribute('data-toggle-expanded');
        if (isExpanded == null || isExpanded == "False" || isExpanded == "false") {
            toggle.setAttribute('data-toggle-expanded', 'false')
            trigger.setAttribute('aria-expanded', 'false');
        } else {
            toggle.setAttribute('data-toggle-expanded', 'true')
            trigger.setAttribute('aria-expanded', 'true');
        }

        trigger.setAttribute('aria-controls', id);
        area.setAttribute('id', id);

        trigger.addEventListener('click', handleTriggerClick);
    }
    function handleTriggerClick(e) {
        e.preventDefault();
        e.stopPropagation();
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        isExpanded ? collapse() : expand();

        // Change button text if of type 'filter-button'
        if (trigger.getAttribute('filter-button') === 'true')
        {
            trigger.textContent = isExpanded ? '+ Visa fler' : '- Visa f\u00E4rre'; // '\u00E4v' = '�'
        }
    }
    function expand() {
        trigger.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('data-toggle-expanded', 'true');
    }
    function collapse() {
        trigger.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('data-toggle-expanded', 'false');
    }
    return {
        init: init
    }
}

controller.add('Toggle', Toggle);

export default Toggle;
